import React from "react";
import { Grid, Icon } from "semantic-ui-react";
import MainButton from "components/Buttons/MainButton";
import { displayGender } from "utils/displayGender";
import displayName from "utils/displayName";
import moment from "moment";
import { isMobile } from "utils/isMobile";

const _appointmentContainer = (prescription, folder, user, isUrgent) => {
	let backgroundColor = "#fff";
	if (prescription?.assigned_secretary && prescription?.assigned_secretary.id !== user.session.id && folder.openedBy?.id !== user.session.id)
		backgroundColor = "#DFDFDF";
	else if (isUrgent) {
		backgroundColor = "rgba(255, 80, 77,0.4)";
	} else if (folder.validation_paused) {
		const pausedTime = moment().diff(folder.validation_paused_at, "hours");
		if (pausedTime > 1) backgroundColor = "rgb(255,0,0,0.25)";
		else if (pausedTime > 0) backgroundColor = "rgb(255,165,0.25)";
		else backgroundColor = "rgb(0,128,0,0.25)";
	}
	return {
		backgroundColor: backgroundColor,
		width: "100%",
		position: "relative",
		padding: 10,
		display: "flex",
		borderRadius: "0",
		marginTop: "5px",
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		alignItems: "center",
		marginRight: 10,
		marginLeft: 10,
	};
};

const FolderListItem = ({ folder, generalParameters, handleOnPress, onPressText = "Voir", user }) => {
	const getAnalysesString = (presc) => {
		let analyses = [];
		let analysesStr = "";
		if (presc?.analyses)
			presc.analyses.forEach((ana) => {
				if (!analyses.includes(ana.properties.code)) analyses.push(ana.properties.code);
			});

		analyses.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

		analysesStr = analyses.reduce((a, b) => a.concat(b + ", "), "");
		analysesStr = analysesStr.substr(0, analysesStr.length - 2);

		return analysesStr;
	};

	const prescription = folder.prescriptions ? folder.prescriptions[0] : null;
	const isUrgent = folder.prescriptions?.findIndex((prescri) => prescri.urgent) > -1;

	return (
		<Grid.Row style={_appointmentContainer(prescription, folder, user, isUrgent)} key={`folder-${folder?.id}`}>
			<Grid.Column mobile={16} tablet={5} computer={5} style={{ paddingLeft: 20 }}>
				<div style={{ paddingLeft: 20, position: "relative" }}>
					<b>
						{displayGender(prescription?.patient ?? folder.patient, generalParameters.data)}
						{displayName(prescription?.patient ?? folder.patient)}
					</b>
					<br />
					<span style={{ fontSize: "0.8em" }}>CNS: {prescription?.patient?.cns ?? folder.patient?.cns}</span>
					<br />
					<span style={{ fontSize: "0.8em", fontStyle: "italic" }}>
						{moment().diff(prescription?.patient?.birth_date ?? folder.patient?.birth_date, "years")} ans
					</span>
				</div>
			</Grid.Column>

			<Grid.Column mobile={16} tablet={4} computer={4} style={{ width: "30%", marginTop: isMobile() ? 10 : 0 }}>
				<div>
					<b style={{ fontSize: "0.8em" }}>
						Dossier {folder.code}
						{folder.date ? ` - ${moment(folder.date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}` : ""}
					</b>
					<br />
					<span style={{ fontSize: "0.8em" }}>Nombre de prescriptions: {folder?.prescriptions?.length || 0}</span>
					<br />
					<span style={{ fontSize: "0.7em" }}>{getAnalysesString(prescription)}</span>
					<br />
					{folder.status === "PENDING" && folder.paused_at && (
						<>
							<Icon name="wait" style={{ color: "#b9c503" }} />
							{`Dossier en attente depuis le ${moment(folder.paused_at).format(
								`${process.env.REACT_APP_DATE_DISPLAY_FORMAT} [à] ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`
							)}`}
						</>
					)}
				</div>
			</Grid.Column>

			<Grid.Column mobile={16} tablet={4} computer={4} style={{ width: "30%", marginTop: isMobile() ? 10 : 0 }}>
				{folder.validation_paused && (
					<>
						<Icon name="wait" style={{ color: "#b9c503" }} />
						<span>Validation en pause</span>
						<br />
						<span>
							{moment(folder.validation_paused_at).format(
								`${process.env.REACT_APP_DATE_DISPLAY_FORMAT} - ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`
							)}{" "}
							- {folder.validation_paused_by?.last_name} {folder.validation_paused_by?.first_name}
						</span>
						<br />
						{folder.validation_paused_reason && <span>Motif: {folder.validation_paused_reason}</span>}
					</>
				)}
				{!folder.validation_paused &&
					prescription?.assigned_secretary &&
					folder.openedBy?.id !== user.session.id &&
					prescription?.assigned_secretary.id !== user.session.id && (
						<div>Secrétaire: {`${prescription?.assigned_secretary.last_name} ${prescription?.assigned_secretary.first_name}`}</div>
					)}
				{isUrgent && (
					<div>
						<Icon name="warning" style={{ color: "#ff0000" }} />
						Dossier urgent
					</div>
				)}
				{folder.openedBy && (
					<div>
						Ouvert par {folder.openedBy.last_name} {folder.openedBy.first_name}
					</div>
				)}
			</Grid.Column>

			<Grid.Column mobile={16} tablet={3} computer={3} style={{ width: "20%", textAlign: "right" }}>
				<MainButton
					text={onPressText}
					onClick={(e) => {
						if (e !== undefined) e.preventDefault();
						handleOnPress();
					}}
				/>
			</Grid.Column>
		</Grid.Row>
	);
};

export default FolderListItem;
